import { selectSmallScreenWarningModal } from "../../store/general/selectors";
import useScreenWidthWarning from "../../hooks/useScreenWidthWarning";
import SmallScreenWarning from "../../containers/SmallScreenWarning";
import IncompleteProfile from "../../containers/IncompleteProfile";
import { selectLogOutModal } from "../../store/auth/selectors";
import { useDispatch, useSelector } from "../../store/store";
import { getUserInfoThunk } from "../../store/auth/thunks";
import UploadAvatar from "../../containers/UploadAvatar";
import WorkspaceLayout from "../../layouts/Workspace";
import Loading from "../../components/Loading";
import SignOut from "../../containers/SignOut";
import { Outlet } from 'react-router-dom';
import { useEffect } from "react";
import {
    getProfileDataThunk,
    getUserAttributesThunk,
} from "../../store/workspace/thunks";
import {
    selectFetchingProfile,
    selectIncompleteProfileModal,
    selectUploadAvatarModal,
} from "../../store/workspace/selectors";

function Workspace() {
    const dispatch = useDispatch();
    const logOutModal = useSelector(selectLogOutModal);
    const fetchingProfile = useSelector(selectFetchingProfile);
    const incompleteProfileModal = useSelector(selectIncompleteProfileModal);
    const uploadAvatarModal = useSelector(selectUploadAvatarModal);
    const smallScreenWarningModal = useSelector(selectSmallScreenWarningModal);
    useScreenWidthWarning(['/workspace']);

    useEffect(() => {
        dispatch(getUserInfoThunk());
    }, []);

    useEffect(() => {
        dispatch(getUserAttributesThunk());
        dispatch(getProfileDataThunk());
    }, []);

    return (
        <WorkspaceLayout>
            <Outlet />
            {logOutModal && <SignOut />}
            {fetchingProfile && <Loading />}
            {uploadAvatarModal && <UploadAvatar />}
            {incompleteProfileModal && <IncompleteProfile />}
            {smallScreenWarningModal && <SmallScreenWarning />}
        </WorkspaceLayout>
    );
};

export default Workspace;
